export default "__VITE_ASSET__3523099d__"